import React from 'react'

import './styles/Player.css'

export default function Player(props) {
  const { name, profile_id, rating, highest_rating } = props.data
  const selected = props.selected
  const setSelectedPlayer = props.setSelectedPlayer
  const key = props.datakey

  return (
    <div
      className={`player-profile ${selected ? 'player-selected' : ''}`}
      onClick={() => {
        setSelectedPlayer(key)
      }}
    >
      <h2>{name}</h2>
      <span className='profileid'>{`(${profile_id})`}</span>
      <span>{`RM: ${rating} (${highest_rating})`}</span>
    </div>
  )
}
